const LazadaKeyValidation = (data) => {

    if (data.message == "Lazada code has expired, or the specified App Key is invalid. Please regenerate it using the correct URL and obtain a new authorization code." && data.status == 422) {
        window.location.href = "https://auth.lazada.com/oauth/authorize?response_type=code&redirect_uri=https://admin.beawms.com/api/lazada/callback&force_auth=true&client_id=132971&redirect_auth=true&country=sg";
        return false;
    }
    return true;
};

export default LazadaKeyValidation;